// src/Public/events-screen-data.js

const EventsScreenData = {
    he: {
        seo: {
            title: 'Your Business | אירועים',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three, keyword four, keyword five',
            image: '/placeholder.svg',
        },
        heroSection: {
            tag: 'Section Title',
            title: 'אירועים',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            heroMedia: '/placeholder.svg',
            // Desktop hero: a moving row of event-card-sized media cards.
            heroShorts: [
               '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
            ],
        },
        landing: {
            title: 'האירועים הקרובים',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        },
        calendar: {
            monthView: 'לוח חודשי',
            listView: 'רשימה',
            today: 'היום',
            upcoming: 'אירועים קרובים',
            past: 'אירועים קודמים',
            viewAll: 'לכל האירועים',
            viewEvent: 'לפרטי האירוע',
            noEvents: 'אין אירועים החודש.',
            allDay: 'כל היום',
            free: 'חינם',
            weekdays: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
            months: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
        },
        postStrings: {
            backToEvents: 'חזרה לאירועים ←',
            when: 'מתי',
            where: 'איפה',
            agenda: 'מהלך האירוע',
            highlights: 'מה מחכה לכם',
            speakers: 'הדוברים',
            gallery: 'גלריה',
            free: 'ללא תשלום',
            from: 'החל מ־',
            spotsLeft: 'מקומות אחרונים',
            register: 'להרשמה',
            addToCalendar: 'הוספה ליומן',
            getDirections: 'הוראות הגעה',
            faq: 'שאלות נפוצות',
            relatedTitle: 'אירועים נוספים',
            multiDay: 'אירוע רב-יומי',
            about: 'אודות',
            readMore: 'קראו עוד',
            readLess: 'הצגת פחות',
            gotCode: 'יש לכם קוד?',
            tickets: 'כרטיסים',
            registrationClosed: 'ההרשמה נסגרה',
            priceNote: 'המחיר שתשלמו. בלי הפתעות.',
            presentedBy: 'מטעם',
            linkCopied: 'הקישור הועתק',
        },

        join: {
            title: 'הרשמה לאירוע',
            intro: 'משאירים פרטים ונחזור אליכם עם כל המידע.',
            name: 'שם מלא',
            email: 'אימייל',
            phone: 'טלפון',
            guests: 'מספר אורחים',
            submit: 'המשך לתשלום',
            submitFree: 'שריינו לי מקום',
            sending: 'שולח...',
            successTitle: 'נרשמתם! 🎉',
            successBody: 'קיבלנו את הפרטים ונחזור אליכם בקרוב.',
            redirecting: 'מעבירים אתכם לעמוד התשלום...',
            pay: 'המשך לתשלום',
            error: 'משהו השתבש, נסו שוב.',
            disclaimer: 'בהשארת הפרטים אתם מאשרים שניצור קשר בנוגע לאירוע.',
            viewDetails: 'לפרטים המלאים',
        },
    },

    en: {
        seo: {
            title: 'Your Business | Events',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three, keyword four, keyword five',
            image: '/placeholder.svg',
        },
        heroSection: {
            tag: 'Section Title',
            title: 'Events',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            heroMedia: '/placeholder.svg',
            // Desktop hero: a moving row of event-card-sized media cards.
            heroShorts: [
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
            ],
        },
        landing: {
            title: 'Upcoming events',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        },
        calendar: {
            monthView: 'Month',
            listView: 'List',
            today: 'Today',
            upcoming: 'Upcoming events',
            past: 'Past events',
            viewAll: 'View all events',
            noEvents: 'No events this month.',
            allDay: 'All day',
            free: 'Free',
            weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        },
        postStrings: {
            backToEvents: '← Back to events',
            when: 'When',
            where: 'Where',
            agenda: 'Run of show',
            highlights: 'What to expect',
            speakers: 'Speakers',
            gallery: 'Gallery',
            free: 'Free',
            from: 'From',
            spotsLeft: 'spots left',
            register: 'Register',
            addToCalendar: 'Add to calendar',
            getDirections: 'Get directions',
            faq: 'FAQ',
            relatedTitle: 'More events',
            multiDay: 'Multi day event',
            about: 'About',
            readMore: 'Read more',
            readLess: 'Read less',
            gotCode: 'Got a code?',
            tickets: 'Tickets',
            registrationClosed: 'Registration closed',
            priceNote: 'The price you’ll pay. No surprises later.',
            presentedBy: 'Presented by',
            linkCopied: 'Link copied',
        },

        join: {
            title: 'Join this event',
            intro: 'Leave your details and we’ll get back to you with everything.',
            name: 'Full name',
            email: 'Email',
            phone: 'Phone',
            guests: 'Guests',
            submit: 'Continue to payment',
            submitFree: 'Save my spot',
            sending: 'Sending...',
            successTitle: 'You’re in! 🎉',
            successBody: 'We’ve got your details and will be in touch soon.',
            redirecting: 'Taking you to the payment page...',
            pay: 'Continue to payment',
            error: 'Something went wrong, please try again.',
            disclaimer: 'By registering you agree that we may contact you about this event.',
            viewDetails: 'View full details',
        },
    },
};

export function getEventsScreenData(lang = 'en') {
    return EventsScreenData[lang] || EventsScreenData.en;
}

export default EventsScreenData;
